import { Box, Checkbox, Grid, InputAdornment, Typography } from "@mui/material"
import VoucherExportButton from "features/manage-crm/voucher/voucher-export"
import MainButton from "new-components/buttons/main-button"
import SelectInput from "new-components/inputs/select-input"
import TextInput from "new-components/inputs/text-input"
import AddCircleIcon from '@mui/icons-material/AddCircle'
import TableCustom from "component/Table/TableCustom"
import { useEffect, useState } from "react"
import VoucherApi from "api/voucher/voucher.api"
import TableRowCommon, { DropdownItem } from "component/Table/TableRowCommon"
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

import { isCopy, isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "component/Loading"
import AlertModal from "new-components/modal/alert-modal"
import SnackbarComponent from "new-components/snackbar/snackbar-component"
import { useHistory } from "react-router-dom"
import { routeName } from 'routes/routes-name'
import PageModal from "new-components/modal/page-modal"
import CheckboxButton from "new-components/buttons/checkbox-button"
import _ from "lodash"
import SelectCheckBoxInput from "new-components/inputs/select_checkbox_input"
import moment from "moment"
import DateRangeInput from "new-components/inputs/date-range-input"
import { dateToView } from "utils/date.utils"
import PromotionsApi from "api/promotion/promotion.api"
import ComponentApi from "api/components-api"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { useTranslation } from "react-i18next"

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView(),
    isCopy: isCopy(),
}

const Voucher = () => {
    ////-------------------
    ////    ROUTE
    ////-------------------
    const history = useHistory()

    ////-------------------
    ////    I18N
    ////-------------------
    const { t } = useTranslation()

    ////-------------------
    ////    STATE
    ////-------------------
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSortType] = useState('DESC')
    const [search, setSearch] = useState('')
    const [statusSelect, setStatusSelect] = useState<string>('ALL')
    const [loading, setLoading] = useState<boolean>(true)

    const [dataVoucher, setDataVoucher] = useState<any>([])

    const [status, setStatus] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [nameEn, setNameEn] = useState('')
    const [alertModal, setAlertModal] = useState(false)
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const [isOpenPageModal, setIsOpenPageModal] = useState(false)
    const [rowCountModal, setRowCountModal] = useState(0)
    const [pageModal, setPageModal] = useState(1)
    const [pageLimitModal, setPageLimitModal] = useState(10)
    const [dataVoucherById, setDataVoucherById] = useState<any>([])
    const [countWaiting, setCountWaiting] = useState('')
    const [countReady, setCountReady] = useState('')
    const [countUsed, setCountUsed] = useState('')
    const [countExpired, setCountExpired] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [searchModal, setSearchModal] = useState('')
    const [statusModal, setStatusModal] = useState<number[]>([])
    const [resultStatus, setResultStatus] = useState('')
    const [lotNumber, setLotNumber] = useState<any>([])
    const [resultLotNumber, setResultLotNumber] = useState('')
    const [optionLotNumber, setOptionLotNumber] = useState([])
    const [dataVoucherList, setDataVoucherList] = useState<any>([])
    const [rangeDate, setRangeDate] = useState<string[]>(['', ''])
    const [subGroup, setSubGroup] = useState('')

    const [loadingModal, setLoadingModal] = useState(false)

    const [copy, setCopy] = useState(0)
    const [lotActionLoading, setLotActionLoading] = useState(false)
    const [alertLotModal, setAlertLotModal] = useState(false)
    const [lotActionData, setLotActionData] = useState<{ lotNumber: number, action: 'ACTIVATE' | 'DEACTIVATE' } | null>(null)
    const [alertSingleModal, setAlertSingleModal] = useState(false)
    const [singleActionData, setSingleActionData] = useState<{ voucherListId: number, voucherCode: string, action: 'ACTIVATE' | 'DEACTIVATE' } | null>(null)
    const [selectedVoucherIds, setSelectedVoucherIds] = useState<number[]>([])
    const [alertBulkModal, setAlertBulkModal] = useState(false)
    const [bulkAction, setBulkAction] = useState<'ACTIVATE' | 'DEACTIVATE' | null>(null)

    const preparation = async (searchData?: string) => {
        setLoading(true)
        const condition = {
            page: page,
            pageLimit: pageLimit,
            SEARCH: searchData === '' ? '' : search,
            sortBy: sortBy,
            sortType: sortType,
            STATUS: statusSelect === 'ALL' ? '' : statusSelect,
            EXPORT: '0',
        }
        const resp: any = await VoucherApi.findAllVoucher(condition)
        if (resp.status === 200) {
            setRowCount(resp?.headers['x-total'] || 0)
            setDataVoucher(resp.data)
        }
        setLoading(false)
    }

    const fetchExportRows = async (): Promise<any[]> => {
        const condition = {
            SEARCH: search,
            sortBy: sortBy,
            sortType: sortType,
            STATUS: statusSelect === 'ALL' ? '' : statusSelect,
            EXPORT: '1',
        }
        const resp: any = await VoucherApi.findAllVoucher(condition)
        return resp?.status === 200 ? (resp.data || []) : []
    }

    const preparationById = async (id: number) => {
        await VoucherApi.findVoucherById(id).then((resp) => {
            setDataVoucherById(resp.data)
        })
    }

    const preparationVoucherId = async (id: number, pageId?: number) => {
        setLoadingModal(true)
        await VoucherApi.findVoucherListId(id, { page: pageId ? pageId : pageModal, pageLimit: pageLimitModal, STATUS: resultStatus, SEARCH: searchModal, startDate: rangeDate[0], endDate: rangeDate[1], lotNumber: resultLotNumber }).then((resp: any) => {
            if (resp.status === 200) {
                const statusReady = _.find(resp.data.statusCounts, (item) => item.status === 'READY')
                const statusWaiting = _.find(resp.data.statusCounts, (item) => item.status === 'WAITING')
                const statusUsed = _.find(resp.data.statusCounts, (item) => item.status === 'USED')
                const statusExpired = _.find(resp.data.statusCounts, (item) => item.status === 'EXPIRED')
                const lotNumbers: any = _.map(resp.data?.lotNumbers, (item) => ({ name: item.lotNumber.toString().padStart(4, '0'), id: item.lotNumber }))
                setRowCountModal(resp?.headers['x-total'] || 0)
                setDataVoucherList(resp.data.rows)
                setCountWaiting(statusWaiting?.count)
                setCountReady(statusReady?.count)
                setCountUsed(statusUsed?.count)
                setCountExpired(statusExpired?.count)
                setOptionLotNumber(lotNumbers)
                setTotalCount(resp.data?.count)
            }
        })
        setLoadingModal(false)
    }

    const preparationPatient = async (data: string) => {
        if (data === 'RANK') {
            const condition: any = { page: 1, pageLimit: 50, sortType: 'ASC', sortBy: 'createdAt', status: 'ACTIVE' }
            await PromotionsApi.findAllRank(condition).then((resPatientTypes) => {
                if (resPatientTypes.status === 200) {
                    const newData = _.map(dataVoucherById?.voucherGroups, (item) => {
                        const result = _.find(resPatientTypes?.data, (items) => items.rankId === item.groupTypeId)
                        return result ? result.rankName : null;
                    })
                    setSubGroup(newData?.join(', '))
                }
            })
        } else {
            const condition: any = { page: 1, pageLimit: 50, sortType: 'ASC', sortBy: 'createdAt', status: 'ACTIVE' }
            await ComponentApi.findAllPatientType(condition).then((resPatientTypes) => {
                if (resPatientTypes.status === 200) {
                    const newData = _.map(dataVoucherById?.voucherGroups, (item) => {
                        const result = _.find(resPatientTypes?.data, (items) => items.patientTypeId === item.groupTypeId)
                        return result ? result.patientTypeName : null;
                    })
                    setSubGroup(newData?.join(', '))
                }
            })
        }
    }

    ////-------------------
    ////    EFFECT
    ////-------------------
    useEffect(() => {
        if (isOpenPageModal) {
            setSelectedVoucherIds([])
            preparationVoucherId(dataVoucherById.voucherId)
        }
    }, [pageModal, pageLimitModal])

    useEffect(() => {
        if (isOpenPageModal) {
            preparationPatient(dataVoucherById?.voucherGroups?.[0]?.groupType)
        }
    }, [dataVoucherById?.voucherGroups?.[0]?.groupType])

    useEffect(() => {
        preparation()

        return () => {
            setId(0)
            setName('')
            setNameEn('')
        }
    }, [page, pageLimit])
    ////-------------------
    ////    HANDLE
    ////-------------------
    const getUsageLabel = (voucherUsage: string) => {
        switch (voucherUsage) {
            case 'ALL': return t('VOUCHER.FORM.USAGE_ALL')
            case 'OPERATIVE': return t('VOUCHER.FORM.USAGE_LIST_DF_CF')
            case 'OPERATIVEDF': return t('VOUCHER.FORM.USAGE_LIST_DF')
            case 'OPERATIVECF': return t('VOUCHER.FORM.USAGE_LIST_CF')
            case 'PRODUCT': return t('VOUCHER.FORM.USAGE_LIST_PD')
            default: return '-'
        }
    }

    const getScopeLabel = (row: any) => {
        const scope = row?.discountScope || (row?.voucherUsage === 'ALL' ? 'TOTAL' : 'ITEM')
        return scope === 'TOTAL' ? t('VOUCHER.FORM.USAGE_ALL') : t('VOUCHER.FORM.USAGE_LIST')
    }

    const getConditionSummary = (row: any) => {
        const parts: string[] = []
        const scope = row?.discountScope || (row?.voucherUsage === 'ALL' ? 'TOTAL' : 'ITEM')
        parts.push(getScopeLabel(row))
        if (scope === 'TOTAL' && row?.voucherUsage !== 'ALL') {
            const usage = getUsageLabel(row?.voucherUsage)
            if (usage && usage !== '-') parts.push(usage)
        } else if (scope === 'ITEM') {
            const usage = getUsageLabel(row?.voucherUsage)
            if (usage && usage !== '-') parts.push(usage)
        }
        const price = row?.voucherPrice != null && row?.voucherPrice !== '' ? `${Number(row.voucherPrice)} ${row?.voucherPriceUnit === 'PERCENT' ? '%' : 'บาท'}` : null
        if (price) parts.push(price)
        if (row?.voucherUsage === 'OPERATIVE' && (row?.voucherPriceDF != null || row?.voucherPriceCF != null)) {
            const unit = row?.voucherPriceDFUnit === 'PERCENT' ? '%' : 'บาท'
            parts.push(`DF ${row?.voucherPriceDF ?? 0}${unit} / CF ${row?.voucherPriceCF ?? 0}${unit}`)
        }
        if (row?.activationMode === 'MANUAL') parts.push(t('VOUCHER.LOT.MODE_MANUAL'))
        if (row?.startDate || row?.endDate) parts.push(`${dateToView(row.startDate) || '-'} - ${dateToView(row.endDate) || '-'}`)
        return parts.length ? parts.join(' · ') : '-'
    }

    const headCells = [
        { id: 'no', disablePadding: false, label: '#', width: '50px', align: 'center', },
        { id: 'voucherTypeName', disablePadding: false, label: t('VOUCHER.TABLE.VOUCHER_TYPENAME'), align: 'left', },
        { id: 'voucherName', disablePadding: false, label: t('VOUCHER.TABLE.VOUCHER_NAME'), align: 'left', },
        { id: 'voucherNameEn', disablePadding: false, label: t('VOUCHER.TABLE.VOUCHER_NAMEEN'), align: 'left', },
        { id: 'condition', disablePadding: false, label: t('VOUCHER.TABLE.CONDITION'), align: 'left', minWidth: '280px' },
        { id: 'activationMode', disablePadding: false, label: t('VOUCHER.TABLE.ACTIVATION_MODE'), align: 'left', width: '220px' },
        { id: 'unit', disablePadding: false, label: t('VOUCHER.TABLE.UNIT'), align: 'center', width: '150px' },
        { id: 'status', disablePadding: false, label: t('VOUCHER.TABLE.VOUCHER_STATUS'), align: 'center', width: '150px' },
        { id: 'updatedBy', disablePadding: false, label: t('VOUCHER.TABLE.UPDATED_BY'), align: 'center', width: '180px' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
    ]

    const renderData = (objData: any, index: number) => {
        index = page * pageLimit - pageLimit + index + 1

        const { voucherId, voucherTypeName, voucherName, voucherNameEn, total, totalUsed, everRedeemed, updatedBy, updatedAt, status, activationMode } = objData
        const conditionSummary = getConditionSummary(objData)
        const activationModeLabel = activationMode === 'MANUAL' ? t('VOUCHER.FORM.SETTING.MANUAL_ACTIVATION') : t('VOUCHER.LOT.MODE_AUTO')

        const usedCount = Number(totalUsed) || 0
        const everRedeemedCount = Number(everRedeemed) || 0
        const isClosed = status === 'CLOSED'
        const isActive = status === 'ACTIVE'
        const isInactive = status === 'INACTIVE'
        const canEdit = (isActive || isInactive) && usedCount === 0
        const canDelete = (isActive || isInactive) && everRedeemedCount === 0
        const canEarlyClose = isActive || isInactive
        const objRenderData = {
            key: voucherId,
            id: voucherId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'left', label: voucherTypeName || '' },
                { option: 'TEXT', align: 'left', label: voucherName || '' },
                { option: 'TEXT', align: 'left', label: voucherNameEn || '' },
                { option: 'TEXT', align: 'left', label: conditionSummary },
                { option: 'TEXT', align: 'left', label: activationModeLabel },
                { option: 'TEXT', align: 'center', label: total || '' },
                { option: 'STATUS', align: 'center', label: status },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        ...(!isClosed
                            ? [
                                { option: 'STATUS_ACTIVE', label: t('VOUCHER.ACTION.STATUS_ACTIVE'), disabled: isActive },
                                { option: 'STATUS_INACTIVE', label: t('VOUCHER.ACTION.STATUS_INACTIVE'), disabled: isInactive },
                                { option: 'DIVIDER', label: '', disabled: false },
                            ]
                            : []),
                        { option: 'VIEW', label: t('VOUCHER.ACTION.VIEW'), disabled: permissions.isView.disabled },
                        ...(canEdit
                            ? [
                                { option: 'EDIT', label: t('VOUCHER.ACTION.EDIT'), disabled: permissions.isUpdate.disabled },
                            ]
                            : []),
                        { option: 'COPY', label: t('VOUCHER.ACTION.COPY'), disabled: permissions.isCopy.disabled },
                        ...(canDelete
                            ? [
                                { option: 'DELETE', label: t('VOUCHER.ACTION.DELETE'), disabled: permissions.isDelete.disabled },
                            ]
                            : []),
                        ...(canEarlyClose
                            ? [{
                                option: 'COMPONANT',
                                label: (
                                    <DropdownItem
                                        key={`close-${voucherId}`}
                                        onClick={() => onEarlyClose(objData)}
                                        disabled={permissions.isUpdate.disabled}
                                    >
                                        <span className="ml-2 align-text-bottom">{t('VOUCHER.ACTION.CLOSE')}</span>
                                    </DropdownItem>
                                ),
                            }]
                            : []),
                    ]
                },
            ]
        }

        return (
            <TableRowCommon
                {...objRenderData}
                onView={() => {
                    setIsOpenPageModal(true)
                    setPageModal(1)
                    preparationById(voucherId)
                    preparationVoucherId(voucherId)
                }}
                oncopy={() => history.push(`${routeName.voucher}/create`, { ...objData, copy: true })}
                onedit={() => history.push(`${routeName.voucher}/update`, { ...objData })}
                ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETED', objRenderData.obj)}
                onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            />
        )
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        if (status === 'DELETED') {
            setStatus("DELETED")
            setId(obj.voucherId)
            setName(obj.voucherName)
            setNameEn(obj.voucherNameEn)
            setAlertModal(true)
        } else {
            setAlertModal(true)
            setId(id)
            setStatus(status)
            setName(obj.voucherName)
            setNameEn(obj.voucherNameEn)
        }
    }

    const onActive = () => {
        if (id) {
            VoucherApi.chagneStatusVoucher(id, status).then((resp) => {
                if (resp.status === 200) {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('VOUCHER.MESSAGE.SUCCESS'))
                    preparation()
                } else {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                }
            }).catch((error) => {
                setAlertModal(false)
                setIsOpenSnack(true)
                setTypeSnack("error")
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setLabelSnack(t('VOUCHER.MESSAGE.DUPICATE'))
                } else {
                    setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onDelete = () => {
        if (id) {
            VoucherApi.deleteVoucher(id).then((resp) => {
                if (resp.status === 200) {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('VOUCHER.MESSAGE.DELETE_SUCCESS'))
                    preparation()
                } else {
                    setAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))

                }
            }).catch((error) => {
                setAlertModal(false)
                setIsOpenSnack(true)
                setTypeSnack("error")
                if (error?.response?.data?.message === 'THIS_VOUCHER_TYPE_IS_BEING_USED' || error?.response?.data?.message === 'THIS_VOUCHER_IS_BEING_USED') {
                    setLabelSnack(t('VOUCHER.MESSAGE.DUPICATE'))
                } else {
                    setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
                }

            })
        }
    }

    const onEarlyClose = (obj: any) => {
        const { voucherId, voucherName, voucherNameEn } = obj
        setStatus('CLOSED')
        setId(voucherId)
        setName(voucherName)
        setNameEn(voucherNameEn)
        setAlertModal(true)
    }

    const onConfirmEarlyClose = () => {
        if (!id) return
        VoucherApi.earlyCloseVoucher(id).then((resp) => {
            if (resp.status === 200) {
                setAlertModal(false)
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(t('VOUCHER.MESSAGE.CLOSE_SUCCESS'))
                preparation()
            }
        }).catch((error) => {
            setAlertModal(false)
            setIsOpenSnack(true)
            setTypeSnack('error')
            const errMsg = error?.response?.data?.message
            if (errMsg === 'VOUCHER_CLOSED') {
                setLabelSnack(t('VOUCHER.MESSAGE.VOUCHER_CLOSED'))
            } else {
                setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
            }
        })
    }

    const handleLotAction = (lotNum: number, action: 'ACTIVATE' | 'DEACTIVATE') => {
        setLotActionData({ lotNumber: lotNum, action })
        setAlertLotModal(true)
    }

    const onConfirmLotAction = async () => {
        if (!lotActionData || !dataVoucherById?.voucherId) return
        setLotActionLoading(true)
        try {
            const resp = await VoucherApi.updateLotStatus(dataVoucherById.voucherId, lotActionData.lotNumber, lotActionData.action)
            if (resp.status === 200) {
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(lotActionData.action === 'ACTIVATE' ? t('VOUCHER.LOT.ACTIVATE_SUCCESS') : t('VOUCHER.LOT.DEACTIVATE_SUCCESS'))
                preparationVoucherId(dataVoucherById.voucherId)
            }
        } catch {
            setIsOpenSnack(true)
            setTypeSnack('error')
            setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
        }
        setAlertLotModal(false)
        setLotActionData(null)
        setLotActionLoading(false)
    }

    const handleSingleAction = (voucherListId: number, voucherCode: string, action: 'ACTIVATE' | 'DEACTIVATE') => {
        setSingleActionData({ voucherListId, voucherCode, action })
        setAlertSingleModal(true)
    }

    const onConfirmSingleAction = async () => {
        if (!singleActionData || !dataVoucherById?.voucherId) return
        setLotActionLoading(true)
        try {
            const resp = await VoucherApi.updateSingleVoucherStatus(dataVoucherById.voucherId, [singleActionData.voucherListId], singleActionData.action)
            if (resp.status === 200) {
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(singleActionData.action === 'ACTIVATE' ? t('VOUCHER.LOT.ACTIVATE_SUCCESS') : t('VOUCHER.LOT.DEACTIVATE_SUCCESS'))
                preparationVoucherId(dataVoucherById.voucherId)
            }
        } catch {
            setIsOpenSnack(true)
            setTypeSnack('error')
            setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
        }
        setAlertSingleModal(false)
        setSingleActionData(null)
        setLotActionLoading(false)
    }

    const selectableItems = dataVoucherList.filter((item: any) => {
        const canSelectByStatus = item.status === 'WAITING' || item.status === 'READY'
        const hasOwner = !!String(item?.ownerName || '').trim()
        return canSelectByStatus && !hasOwner
    })

    useEffect(() => {
        if (!selectedVoucherIds.length) return
        const selectableIdSet = new Set(selectableItems.map((item: any) => item.voucherListId))
        setSelectedVoucherIds((prev) => prev.filter((id) => selectableIdSet.has(id)))
    }, [dataVoucherList])

    const handleToggleSelect = (voucherListId: number) => {
        const row = dataVoucherList.find((item: any) => item.voucherListId === voucherListId)
        const hasOwner = !!String(row?.ownerName || '').trim()
        if (hasOwner) return
        setSelectedVoucherIds(prev =>
            prev.includes(voucherListId) ? prev.filter(id => id !== voucherListId) : [...prev, voucherListId]
        )
    }

    const handleSelectAll = () => {
        if (selectedVoucherIds.length === selectableItems.length) {
            setSelectedVoucherIds([])
        } else {
            setSelectedVoucherIds(selectableItems.map((item: any) => item.voucherListId))
        }
    }

    const handleBulkAction = (action: 'ACTIVATE' | 'DEACTIVATE') => {
        setBulkAction(action)
        setAlertBulkModal(true)
    }

    const onConfirmBulkAction = async () => {
        if (!bulkAction || selectedVoucherIds.length === 0 || !dataVoucherById?.voucherId) return
        setLotActionLoading(true)
        try {
            const resp = await VoucherApi.updateSingleVoucherStatus(dataVoucherById.voucherId, selectedVoucherIds, bulkAction)
            if (resp.status === 200) {
                setIsOpenSnack(true)
                setTypeSnack('success')
                setLabelSnack(bulkAction === 'ACTIVATE' ? t('VOUCHER.LOT.ACTIVATE_SUCCESS') : t('VOUCHER.LOT.DEACTIVATE_SUCCESS'))
                setSelectedVoucherIds([])
                preparationVoucherId(dataVoucherById.voucherId)
            }
        } catch {
            setIsOpenSnack(true)
            setTypeSnack('error')
            setLabelSnack(t('VOUCHER.MESSAGE.ERROR'))
        }
        setAlertBulkModal(false)
        setBulkAction(null)
        setLotActionLoading(false)
    }

    const handleVoucherUsage = () => {
        const scope = dataVoucherById?.discountScope || (dataVoucherById?.voucherUsage === 'ALL' ? 'TOTAL' : 'ITEM')
        const scopeLabel = scope === 'TOTAL' ? 'ลดจากราคารวม' : 'ลดจากรายการ'
        switch (dataVoucherById?.voucherUsage) {
            case "ALL":
                return `${scopeLabel} (ทุกรายการ)`
            case "OPERATIVE":
                return `${scopeLabel} · หัตถการ (ลดทั้ง DF และ CF)`
            case "OPERATIVEDF":
                return `${scopeLabel} · หัตถการเฉพาะ DF`
            case "OPERATIVECF":
                return `${scopeLabel} · หัตถการเฉพาะ CF`
            case "PRODUCT":
                return `${scopeLabel} · ยาและผลิตภัณฑ์`
            default:
                return '-'
        }
    }

    const isManualMode = dataVoucherById?.activationMode === 'MANUAL'

    const headCellsModal = [
        ...(isManualMode ? [{
            id: 'checkbox', disablePadding: true, label: '',  width: '50px',
            component: <Checkbox size="small" checked={selectableItems.length > 0 && selectedVoucherIds.length === selectableItems.length} indeterminate={selectedVoucherIds.length > 0 && selectedVoucherIds.length < selectableItems.length} onChange={handleSelectAll} />
        }] : []),
        { id: 'no', disablePadding: false, label: '#', width: '60px' },
        { id: 'id', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.ID') },
        { id: 'group', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.STATUS'), align: 'center', width: '100px' },
        { id: 'type', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.LOTNUMBER'), align: 'center', width: '120px' },
        { id: 'list', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.START_DATE'), align: 'center', width: '150px' },
        { id: 'qty', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.END_DATE'), align: 'center', width: '150px' },
        { id: 'qty', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.OWNER'), align: 'center', width: '200px' },
        { id: 'qty', disablePadding: false, label: t('VOUCHER.FORM.TABLE_VOUCHER_LIST.UPDATED_BY'), align: 'center', width: '200px' },
        ...(isManualMode ? [{ id: 'action', disablePadding: false, label: t('VOUCHER.SINGLE.ACTION_LABEL'), align: 'center' as const, width: '120px' }] : []),
    ]

    const renderDataModal = (objData: any, index: number) => {
        index = pageModal * pageLimitModal - pageLimitModal + index + 1
        const { voucherCode, status, lotNumber, startDate, endDate, ownerName, usedDate, updatedBy, updatedAt, voucherListId } = objData
        const statusType = (status: string) => {
            switch (status) {
                case 'READY':
                    return 'พร้อมใช้งาน'
                case 'WAITING':
                    return 'รอใช้งาน'
                case 'USED':
                    return 'ใช้งานแล้ว'
                case 'EXPIRED':
                    return 'หมดอายุ'
                default:
                    return ''
            }
        }

        const handleCopy = (voucherCode: any, index: number) => {
            setCopy(index);
            navigator.clipboard.writeText(voucherCode);
            setTimeout(() => {
                setCopy(0);
            }, 2000);
        };

        const canSelect = (status === 'WAITING' || status === 'READY') && !String(ownerName || '').trim()

        const objRenderData = {
            key: voucherListId,
            id: voucherListId,
            obj: objData,
            columns: [
                ...(isManualMode ? [{
                    option: 'COMPONENT', align: 'center', component:
                        canSelect ? (
                            <Checkbox size="small" checked={selectedVoucherIds.includes(voucherListId)} onChange={() => handleToggleSelect(voucherListId)} />
                        ) : <Box width="42px" />
                }] : []),
                { option: 'TEXT', align: 'center', label: index },
                {
                    option: 'COMPONENT', align: 'left', component:
                        <Box
                            onClick={() => status === "READY" && navigator.clipboard.writeText(voucherCode)}
                            sx={{ cursor: 'pointer', position: 'relative' }}
                        >
                            <Box display="flex" flexDirection="row" alignItems="center" gap="8px" position="relative">
                                <Typography>{voucherCode}</Typography>
                                <Box>
                                    {copy === index &&
                                        <Box position="absolute" padding="10px" bgcolor="#5A5A5A" color="#FFFFFF" borderRadius="2px" top="-40px" fontSize="14px" fontWeight={400}>Copied</Box>
                                    }
                                    {status === 'READY' && <ContentCopyIcon onClick={() => handleCopy(voucherCode, index)} sx={{ color: '#808080', height: '22px', width: '20px' }} />}
                                </Box>
                            </Box>
                        </Box>
                }, { option: 'COMPONENT', align: 'center', component: <Box fontSize="16px" fontWeight={400} color={status === 'READY' ? '#1CB99A' : status === 'WAITING' ? '#EDBA07' : status === 'USED' ? '#5A5A5A' : '#B00020'}>{statusType(status)}</Box> },
                { option: 'TEXT', align: 'center', label: lotNumber.toString().padStart(4, '0') || '' },
                { option: 'TEXT', align: 'center', label: dateToView(startDate) || '' },
                { option: 'TEXT', align: 'center', label: dateToView(endDate) || '' },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: ownerName || '-', updatedAt: usedDate !== null ? usedDate : '-' } },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                ...(isManualMode ? [{
                    option: 'COMPONENT', align: 'center', component:
                        status === 'WAITING' ? (
                            <MainButton
                                onClick={() => handleSingleAction(voucherListId, voucherCode, 'ACTIVATE')}
                                title={t('VOUCHER.SINGLE.ACTIVATE')}
                                type="primary"
                                variant="contained"
                                style={{ height: '28px', fontSize: '12px', minWidth: '80px' }}
                                disabled={lotActionLoading}
                            />
                        ) : status === 'READY' && !ownerName ? (
                            <MainButton
                                onClick={() => handleSingleAction(voucherListId, voucherCode, 'DEACTIVATE')}
                                title={t('VOUCHER.SINGLE.DEACTIVATE')}
                                type="secondary"
                                variant="outlined"
                                style={{ height: '28px', fontSize: '12px', minWidth: '80px' }}
                                disabled={lotActionLoading}
                            />
                        ) : (
                            <Typography fontSize="12px" color="#A8A8A8">-</Typography>
                        )
                }] : []),
            ]
        }

        return (
            <TableRowCommon {...objRenderData} />
        )
    }

    const headCellsGV = [
        { id: 'no', disablePadding: false, label: t('VOUCHER.FORM.TABLE.NO'), width: '100px' },
        { id: 'voucherUsage', disablePadding: false, label: t('VOUCHER.FORM.TABLE.CATEGORY') },
        { id: 'type', disablePadding: false, label: t('VOUCHER.FORM.TABLE.TYPE') },
        { id: 'list', disablePadding: false, label: t('VOUCHER.FORM.TABLE.LIST') },
        { id: 'amount', disablePadding: false, label: t('VOUCHER.FORM.TABLE.AMOUNT') },
    ]

    const renderDataGV = (objData: any, index: number) => {
        const objRenderData = {
            key: '',
            id: '',
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index + 1 },
                { option: 'TEXT', align: 'left', label: objData?.itemType === 'OPERATIVE' ? 'รายการหัตถการ' : objData?.itemType === 'MEDICINE' ? 'ยา' : 'สินค้าและผลิตภัณฑ์' },
                { option: 'TEXT', align: 'left', label: objData?.itemTypeName || '-' },
                { option: 'TEXT', align: 'left', label: objData?.itemName || '-' },
                { option: 'TEXT', align: 'left', label: objData?.qty || '-' },
            ]
        }

        return (
            <TableRowCommon {...objRenderData} />
        )
    }

    const handleTotalPrice = () => {

        return dataVoucherById?.voucherItems?.reduce((acc: number, item: any) => {
            if (item.itemPrice && item.qty) {
                return acc + (item.itemPrice * item.qty);
            }
            return acc
        }, 0)?.toLocaleString()
    }


    return (
        <Box>
            <Loading show={loadingModal} />
            <PageModal
                isOpen={isOpenPageModal}
                title={t('VOUCHER.VOUCHER_VIEW.TITLE')}
                size="L"
                onSubmit={{ onClick: () => null }}
                onCancel={{ onClick: () => setIsOpenPageModal(false), title: t('VOUCHER.FORM.BUTTON_CANCEL') }}
                onCloseSubmit
                handleClose={() => setIsOpenPageModal(false)}
            >
                <Box sx={{ minHeight: 0, px: 0 }}>
                    <Grid container spacing={2}>
                        {/* แถวที่ 1: ชื่อ + ประเภท */}
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.VOUCHER_NAME')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherName} {dataVoucherById?.voucherNameEn && `(${dataVoucherById?.voucherNameEn})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.VOUCHER_TYPE')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherType?.voucherTypeName}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* แถวที่ 2: ประเภทมูลค่า + มูลค่า */}
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.PRICE_TYPE')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>
                                        {dataVoucherById?.voucherPriceType === 'SALEPRICE' ? t('VOUCHER.FORM.PRICE_TYPE_VIEW_SALEPRICE') : t('VOUCHER.FORM.PRICE_TYPE_VIEW_DISCOUNT')}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.PRICE_TYPE_COST')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherPrice} {dataVoucherById?.voucherPriceUnit === "PERCENT" ? '%' : 'บาท'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* แถวที่ 3: ยอดขั้นต่ำ + การใช้งาน */}
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.MINIMUM')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.minimum} บาท</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.USAGE')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>{handleVoucherUsage()}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {dataVoucherById?.voucherUsage === 'OPERATIVE' && (dataVoucherById?.voucherPriceDF != null || dataVoucherById?.voucherPriceCF != null) && (
                            <Grid item xs={12} sm={6}>
                                <Grid container alignItems="center">
                                    <Grid item xs={5} sx={{ minWidth: 140 }}>
                                        <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.DF_CF')}</Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography fontSize="14px" fontWeight={400}>
                                            DF {dataVoucherById?.voucherPriceDF ?? 0} {dataVoucherById?.voucherPriceDFUnit === 'PERCENT' ? '%' : 'บาท'} / CF {dataVoucherById?.voucherPriceCF ?? 0} {dataVoucherById?.voucherPriceDFUnit === 'PERCENT' ? '%' : 'บาท'}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        {/* วันที่เริ่ม-สิ้นสุด */}
                        <Grid item xs={12} sm={6}>
                            <Grid container alignItems="center">
                                <Grid item xs={5} sx={{ minWidth: 140 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.DATE_RANGE')}</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography fontSize="14px" fontWeight={400}>
                                        {dateToView(dataVoucherById?.startDate) || '-'} - {dateToView(dataVoucherById?.endDate) || '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* รายละเอียด */}
                        <Grid item xs={12}>
                            <Grid container alignItems="flex-start">
                                <Grid item xs={12} sm={2} sx={{ minWidth: 100 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.DETAIL')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={10}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.detail || '-'}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* ผูกกับรายการหัตถการ */}
                        <Grid item xs={12}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={4} sx={{ minWidth: 180 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.BIND_OP_MED_PD')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherItems?.length > 0 ? t('VOUCHER.FORM.VALUE_YES') : t('VOUCHER.FORM.VALUE_NO')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {dataVoucherById.voucherItems?.length > 0 &&
                                <Box sx={{ mt: 2 }}>
                                    <Typography fontSize="14px" fontWeight={500} sx={{ mb: 1 }}>{dataVoucherById.voucherItems.length > 1 ? t('VOUCHER.FORM.BIND_OP_MED_PD_DETAIL_ALL') : t('VOUCHER.FORM.BIND_OP_MED_PD_DETAIL')}</Typography>
                                    <TableCustom
                                        page={1}
                                        pageLimit={99}
                                        sortType={''}
                                        sortBy={''}
                                        onSort={() => console.log()}
                                        setPageLimit={() => console.log()}
                                        setPage={() => console.log()}
                                        rowCount={1}
                                        hidePagination
                                        headCells={headCellsGV}
                                        rowsData={dataVoucherById.voucherItems.map((item: any, index: number) => {
                                            return renderDataGV(item, index)
                                        })}

                                    />
                                </Box>
                            }
                        </Grid>
                        {dataVoucherById?.voucherItems?.length > 0 && (
                            <Grid item xs={12}>
                                <Box sx={{ width: '100%', bgcolor: '#F7F8F8', py: 1.5, px: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                                    <Typography fontSize="14px" fontWeight={500}>{t('VOUCHER.FORM.TOTALPRICE')}</Typography>
                                    <Typography fontSize="14px" fontWeight={400}>{handleTotalPrice()} {t('VOUCHER.FORM.BAHT')}</Typography>
                                </Box>
                            </Grid>
                        )}
                        {/* ตั้งค่าอื่นๆ */}
                        <Grid item xs={12} sx={{ mt: 2 }}>
                            <Typography fontSize="16px" fontWeight={600}>{t('VOUCHER.FORM.SETTING.TITLE')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={4} sx={{ minWidth: 180 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.SETTING.PREFIX_ID')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherPrefix ? t('VOUCHER.FORM.VALUE_YES') : t('VOUCHER.FORM.VALUE_NO')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {dataVoucherById?.voucherPrefix && (
                                        <Typography fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.SETTING.PREFIX_ID_INPUT')}: {dataVoucherById?.voucherPrefix}</Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={4} sx={{ minWidth: 180 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.SETTING.PATIENT')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherGroups?.length > 0 ? t('VOUCHER.FORM.VALUE_YES') : t('VOUCHER.FORM.VALUE_NO')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {dataVoucherById?.voucherGroups?.length > 0 && (
                                        <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.voucherGroups?.[0]?.groupType} : {subGroup}</Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={4} sx={{ minWidth: 180 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.FORM.SETTING.USE_VOUCHER_DONT_PATIENT')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Typography fontSize="14px" fontWeight={400}>{dataVoucherById?.connectPatient === '1' ? t('VOUCHER.FORM.VALUE_YES') : t('VOUCHER.FORM.VALUE_NO')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container alignItems="flex-start">
                                <Grid item xs={12} sm={4} sx={{ minWidth: 180 }}>
                                    <Typography fontSize="14px" fontWeight={500} color="text.secondary">{t('VOUCHER.LOT.ACTIVATION_MODE')}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Typography fontSize="14px" fontWeight={400} sx={{ maxWidth: 420 }} color={dataVoucherById?.activationMode === 'MANUAL' ? '#1CB99A' : '#5A5A5A'}>
                                        {dataVoucherById?.activationMode === 'MANUAL' ? t('VOUCHER.FORM.SETTING.MANUAL_ACTIVATION') : t('VOUCHER.LOT.MODE_AUTO')}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}><Box border="1px solid" borderColor="#E5E5E5" width="100%" sx={{ my: 2 }} /></Grid>
                        <Grid item xs={12}><Typography fontSize="18px" fontWeight={600}>{t('VOUCHER.FORM.LIST_VOUCHER_ID')}</Typography></Grid>
                        <Grid item xs={12}>
                            <Box display="flex" flexWrap="wrap" alignItems="center" gap={2} sx={{ mb: 1 }}>
                                <Typography color="text.secondary" fontSize="14px" fontWeight={500}>{t('VOUCHER.FORM.STATUS')}</Typography>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography color="#EDBA07" fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_WAITING')}</Typography>
                                    <Typography fontSize="14px" fontWeight={400}>{countWaiting || 0}/{totalCount}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography color="#1CB99A" fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_READY')}</Typography>
                                    <Typography fontSize="14px" fontWeight={400}>{countReady || 0}/{totalCount}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography color="#5A5A5A" fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_USED')}</Typography>
                                    <Typography fontSize="14px" fontWeight={400}>{countUsed || 0}/{totalCount}</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography color="#B00020" fontSize="14px" fontWeight={400}>{t('VOUCHER.FORM.STATUS_EXPIRED')}</Typography>
                                    <Typography fontSize="14px" fontWeight={400}>{countExpired || 0}/{totalCount}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                        {dataVoucherById?.activationMode === 'MANUAL' && optionLotNumber?.length > 0 && (
                            <Grid item xs={12}>
                                <Box border="1px solid #E5E5E5" borderRadius="8px" sx={{ p: 2, mb: 1 }}>
                                    <Typography fontSize="14px" fontWeight={500} sx={{ mb: 1.5 }}>
                                        {t('VOUCHER.LOT.TITLE')}
                                    </Typography>
                                    <Box display="flex" flexWrap="wrap" gap={1.5}>
                                        {optionLotNumber.map((lot: any) => {
                                            const lotItems = dataVoucherList.filter((item: any) => item.lotNumber === lot.id)
                                            const hasWaiting = lotItems.some((item: any) => item.status === 'WAITING') || lotItems.length === 0
                                            const hasReady = lotItems.some((item: any) => item.status === 'READY')
                                            return (
                                                <Box
                                                    key={lot.id}
                                                    display="flex"
                                                    alignItems="center"
                                                    gap="8px"
                                                    border="1px solid #E5E5E5"
                                                    borderRadius="4px"
                                                    padding="8px 16px"
                                                >
                                                    <Typography fontSize="14px" fontWeight={500}>
                                                        Lot {lot.name}
                                                    </Typography>
                                                    <MainButton
                                                        onClick={() => handleLotAction(lot.id, 'ACTIVATE')}
                                                        title={t('VOUCHER.LOT.ACTIVATE')}
                                                        type="primary"
                                                        variant="contained"
                                                        style={{ height: '32px', fontSize: '13px' }}
                                                        startIcon={<PlayCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                                        disabled={lotActionLoading}
                                                    />
                                                    <MainButton
                                                        onClick={() => handleLotAction(lot.id, 'DEACTIVATE')}
                                                        title={t('VOUCHER.LOT.DEACTIVATE')}
                                                        type="secondary"
                                                        variant="outlined"
                                                        style={{ height: '32px', fontSize: '13px' }}
                                                        startIcon={<PauseCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                                        disabled={lotActionLoading}
                                                    />
                                                </Box>
                                            )
                                        })}
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                        <Grid item xs={3}> <TextInput label={t('VOUCHER.FORM.SEARCH')} onChange={(e) => setSearchModal(e.target.value)} fullWidth value={searchModal} /></Grid>
                        <Grid item xs={3}> <SelectCheckBoxInput
                            label={t('VOUCHER.FORM.STATUS_FITTER.STATUS')}
                            onChange={(e) => {
                                setStatusModal(e)
                                const result = e.join(',')
                                setResultStatus(result)
                            }}
                            options={[
                                { name: t('VOUCHER.FORM.STATUS_FITTER.WAITING'), id: 'WAITING', },
                                { name: t('VOUCHER.FORM.STATUS_FITTER.READY'), id: 'READY', },
                                { name: t('VOUCHER.FORM.STATUS_FITTER.USED'), id: 'USED', },
                                { name: t('VOUCHER.FORM.STATUS_FITTER.EXPIRED'), id: 'EXPIRED' }
                            ]}
                            selected={statusModal || []}
                        /></Grid>
                        <Grid item xs={3}>
                            <SelectCheckBoxInput
                                label={t('VOUCHER.FORM.LOTNUMBER')}
                                onChange={(e) => {
                                    setLotNumber(e)
                                    const result = e.join(',')
                                    setResultLotNumber(result)
                                }}
                                options={optionLotNumber}
                                selected={lotNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" gap="16px">
                                <DateRangeInput
                                    inputHeight={40}
                                    value={rangeDate || ['', '']}
                                    onchange={(val: any) => {
                                        if (_.isEmpty(val)) setRangeDate(['', ''])
                                        else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                    }}
                                    label={''}
                                    allowClear
                                    onClear={() => setRangeDate(['', ''])}
                                />
                                <MainButton onClick={() => {
                                    setPageModal(1)
                                    preparationVoucherId(dataVoucherById.voucherId, 1)
                                }} title={t('VOUCHER.FORM.SEARCH_VOUCHER_LIST')} type="primary" variant="contained" style={{ width: '120px' }} />
                            </Box>
                        </Grid>
                    </Grid>
                    {isManualMode && selectedVoucherIds.length > 0 && (
                        <Box marginTop="16px" display="flex" alignItems="center" gap="12px" padding="12px 16px" bgcolor="#F0F7FF" borderRadius="8px">
                            <Typography fontSize="14px" fontWeight={500}>
                                {t('VOUCHER.BULK.SELECTED', { count: selectedVoucherIds.length })}
                            </Typography>
                            <MainButton
                                onClick={() => handleBulkAction('ACTIVATE')}
                                title={t('VOUCHER.BULK.ACTIVATE')}
                                type="primary"
                                variant="contained"
                                style={{ height: '32px', fontSize: '13px' }}
                                startIcon={<PlayCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                disabled={lotActionLoading}
                            />
                            <MainButton
                                onClick={() => handleBulkAction('DEACTIVATE')}
                                title={t('VOUCHER.BULK.DEACTIVATE')}
                                type="secondary"
                                variant="outlined"
                                style={{ height: '32px', fontSize: '13px' }}
                                startIcon={<PauseCircleOutlineIcon sx={{ fontSize: '18px' }} />}
                                disabled={lotActionLoading}
                            />
                            <MainButton
                                onClick={() => setSelectedVoucherIds([])}
                                title={t('VOUCHER.BULK.CLEAR')}
                                type="secondary"
                                variant="outlined"
                                style={{ height: '32px', fontSize: '13px' }}
                            />
                        </Box>
                    )}
                    <Box marginTop="16px" >
                        <TableCustom
                            headCells={headCellsModal}
                            onSort={(sortByVal: string, sortTypeVal: string) => {
                                setSortType(sortTypeVal)
                                setSortBy(sortByVal)
                            }}
                            page={pageModal}
                            pageLimit={pageLimitModal}
                            rowsData={dataVoucherList.map((item: any, index: number) => {
                                return renderDataModal(item, index)
                            })}
                            setPage={(e) => setPageModal(e)}
                            setPageLimit={(e) => setPageLimitModal(e)}
                            sortBy={sortBy}
                            sortType={sortType}
                            rowCount={rowCountModal}
                        />
                    </Box>
                </Box>
            </PageModal>
            <AlertModal
                isOpen={alertLotModal}
                title={lotActionData?.action === 'ACTIVATE' ? t('VOUCHER.LOT.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.LOT.CONFIRM_DEACTIVATE_TITLE')}
                message={lotActionData?.action === 'ACTIVATE' ? t('VOUCHER.LOT.CONFIRM_ACTIVATE_MSG', { lot: String(lotActionData?.lotNumber || 0).padStart(4, '0') }) : t('VOUCHER.LOT.CONFIRM_DEACTIVATE_MSG', { lot: String(lotActionData?.lotNumber || 0).padStart(4, '0') })}
                type="warning"
                onSubmit={{ onClick: onConfirmLotAction, title: t('VOUCHER.LOT.CONFIRM') }}
                onCancel={{ onClick: () => { setAlertLotModal(false); setLotActionData(null) }, title: t('VOUCHER.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => { setAlertLotModal(false); setLotActionData(null) }}
            />
            <AlertModal
                isOpen={alertSingleModal}
                title={singleActionData?.action === 'ACTIVATE' ? t('VOUCHER.SINGLE.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.SINGLE.CONFIRM_DEACTIVATE_TITLE')}
                message={singleActionData?.action === 'ACTIVATE' ? t('VOUCHER.SINGLE.CONFIRM_ACTIVATE_MSG', { code: singleActionData?.voucherCode || '' }) : t('VOUCHER.SINGLE.CONFIRM_DEACTIVATE_MSG', { code: singleActionData?.voucherCode || '' })}
                type="warning"
                onSubmit={{ onClick: onConfirmSingleAction, title: t('VOUCHER.LOT.CONFIRM') }}
                onCancel={{ onClick: () => { setAlertSingleModal(false); setSingleActionData(null) }, title: t('VOUCHER.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => { setAlertSingleModal(false); setSingleActionData(null) }}
            />
            <AlertModal
                isOpen={alertBulkModal}
                title={bulkAction === 'ACTIVATE' ? t('VOUCHER.BULK.CONFIRM_ACTIVATE_TITLE') : t('VOUCHER.BULK.CONFIRM_DEACTIVATE_TITLE')}
                message={bulkAction === 'ACTIVATE' ? t('VOUCHER.BULK.CONFIRM_ACTIVATE_MSG', { count: selectedVoucherIds.length }) : t('VOUCHER.BULK.CONFIRM_DEACTIVATE_MSG', { count: selectedVoucherIds.length })}
                type="warning"
                onSubmit={{ onClick: onConfirmBulkAction, title: t('VOUCHER.LOT.CONFIRM') }}
                onCancel={{ onClick: () => { setAlertBulkModal(false); setBulkAction(null) }, title: t('VOUCHER.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => { setAlertBulkModal(false); setBulkAction(null) }}
            />
            <Loading show={loading} />
            <AlertModal
                isOpen={alertModal}
                title={status === "DELETED" ? t('VOUCHER.MESSAGE.DELETE_TITLE') : status === 'CLOSED' ? t('VOUCHER.MESSAGE.CLOSE_TITLE') : status === 'INACTIVE' ? t('VOUCHER.MESSAGE.STATUS_INACTIVE_TITLE') : t('VOUCHER.MESSAGE.STATUS_ACTIVE_TITLE')}
                message={status === "DELETED" ? t('VOUCHER_TYPE.MESSAGE.DELETE_MESSAGE', { name: name, nameEn: nameEn && `(${nameEn})` }) : status === 'CLOSED' ? t('VOUCHER.MESSAGE.CLOSE_MESSAGE', { name: name, nameEn: nameEn && `(${nameEn})` }) : t('VOUCHER.MESSAGE.STATUS_MESSAGE')}
                type={status === "DELETED" ? 'error' : 'warning'}
                onSubmit={{ onClick: status === 'DELETED' ? onDelete : status === 'CLOSED' ? onConfirmEarlyClose : onActive, title: status === "DELETED" ? t('VOUCHER.MESSAGE.BUTTON_SAVE_DELETE') : status === 'CLOSED' ? t('VOUCHER.MESSAGE.BUTTON_SAVE_CLOSE') : t('VOUCHER.MESSAGE.BUTTON_SAVE_ACTIVE') }}
                onCancel={{ onClick: () => setAlertModal(false), title: t('VOUCHER.MESSAGE.BUTTON_CANCEL') }}
                handleClose={() => setAlertModal(false)}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <Box width="100%" height="80px" boxShadow="0px 3px 6px 0px #0000001F" border="1px solid #E5E5E5" paddingLeft="24px" display="flex" alignItems="center" fontSize="20px" fontWeight={500}  >
                {t('VOUCHER.TITLE')}
            </Box>
            <Box paddingX="24px" paddingTop="16px">
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5} lg={4}>
                                <TextInput
                                    onChange={(event) => {
                                        setSearch(event.target.value);
                                        setPage(1);
                                    }}
                                    label={t('VOUCHER.SEARCH')}
                                    value={search}
                                    size='large'
                                    fullWidth={true}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            setPage(1)
                                            preparation()
                                        }
                                    }}
                                    inputProps={{
                                        value: search,
                                        endAdornment: (
                                            <InputAdornment position="end" >
                                                {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                                    <FontAwesomeIcon
                                                        icon={faTimes}
                                                        onClick={() => {
                                                            setSearch('');
                                                            setPage(1);
                                                            preparation('')
                                                        }}
                                                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={5} lg={4}>
                                <SelectInput
                                    value={statusSelect}
                                    onChange={(event: any) => {
                                        setStatusSelect(event.target.value)
                                    }}
                                    defaultValue={statusSelect}
                                    label={t('VOUCHER.STATUS.STATUS')}
                                    options={[
                                        { name: t('VOUCHER.STATUS.ALL'), value: "ALL" },
                                        { name: t('VOUCHER.STATUS.ACTIVE'), value: "ACTIVE" },
                                        { name: t('VOUCHER.STATUS.INACTIVE'), value: "INACTIVE" }
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} lg={4}>
                                <MainButton
                                    title={t('VOUCHER.BUTTON.SEARCH')}
                                    onClick={() => {
                                        setPage(1)
                                        preparation()
                                    }}
                                    type="primary"
                                    variant="contained"
                                    style={{ height: '40px', width: '100px' }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', justifyContent: "flex-end", gap: '16px' }}>
                            <VoucherExportButton
                                fetchRows={fetchExportRows}
                                search={search}
                                statusSelect={statusSelect}
                                getConditionSummary={getConditionSummary}
                                fileName={'รายการประเภท Gift Voucher'}
                                title={'รายการประเภท Gift Voucher'}
                            />
                            <MainButton
                                onClick={() => history.push(`${routeName.voucher}/create`)}
                                title={t('VOUCHER.BUTTON.CREATE_VOUCHER')}
                                type="primary"
                                variant="contained"
                                startIcon={<AddCircleIcon />}
                                style={{ height: '40px' }}
                                disabled={permissions.isCreate.disabled}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box marginTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={(sortByVal: string, sortTypeVal: string) => {
                            setSortType(sortTypeVal)
                            setSortBy(sortByVal)
                        }}
                        setPageLimit={(e) => setPageLimit(e)}
                        setPage={(e) => setPage(e)}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={dataVoucher.map((item: any, index: number) => {
                            return renderData(item, index)
                        })}
                    />
                </Box>
            </Box>
        </Box>
    )
}
export default Voucher